<template>
    <span class="tag is-primary is-light has-text-weight-medium">{{ label }}</span>
</template>

<script>
export default {
  name: 'HtmlTag',
  props: {
    label: String
  }
}
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/forms/HtmlTag.vue